import { useGlobalLoading } from "@/contexts/GlobalLoadingContext";

/**
 * Suspense fallback for route-chunk loading. Renders nothing itself —
 * registers with the same GlobalLoadingContext that each page's own data
 * fetch reports to (see useGlobalLoading calls across app pages), so
 * GlobalLoadingBar stays up across BOTH the chunk download and the
 * page's subsequent data fetch as one continuous "loading" window,
 * instead of resetting between the two phases (which showed the bar, hid
 * it once the chunk resolved, then left a blank gap while data was still
 * loading).
 */
export function DelayedSpinner() {
  useGlobalLoading(true);
  return null;
}
